export default "__VITE_ASSET__Bwh6k3tZ__"